import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteNav } from '../../components/SiteNav';
import { SiteFooter } from '../../components/SiteFooter';
import { RealmHero } from '../../components/realm/RealmHero';
import { RealmNavigator } from '../../components/realm/RealmNavigator';
import { ArtifactsSection } from '../../components/realm/ArtifactsSection';
import { RealmQuote } from '../../components/realm/RealmQuote';
import { usePageMeta } from '../../hooks/usePageMeta';
import { DESCENT, DESCENT_ARTIFACTS, DESCENT_ARTIFACTS_MORE } from '../../data/descentArtifacts';

export default function DescentRealm() {
  const { hash } = useLocation();
  usePageMeta({
    title: 'The Descent — Realm II | Ikarus Landed',
    description: 'The abyss remembered. Five black-stone artifacts of the crossing — Bâton Styx, The Abyss, The Benediction, The Embrace, The Thorn Circle — in black moissanite or the colorless EX edition. Made to order by private commission.',
  });

  useEffect(() => {
    if (hash === '#artifacts') {
      const t = setTimeout(() => document.getElementById('artifacts')?.scrollIntoView({ behavior: 'smooth' }), 150);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [hash]);

  const explore = () => document.getElementById('artifacts')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="luxury-landing realm realm--descent" data-testid="realm-page-the-descent">
      <SiteNav interest="The Descent" />
      <RealmHero realm={DESCENT} onExplore={explore} />
      <RealmNavigator active={DESCENT.slug} />
      <ArtifactsSection realm={DESCENT} featured={DESCENT_ARTIFACTS} more={DESCENT_ARTIFACTS_MORE} />
      <RealmQuote quote={DESCENT.quote} art={DESCENT.quoteArt} artRight={DESCENT.quoteArtRight} />
      <SiteFooter />
    </div>
  );
}
